import { render } from "./DefLabels.vue?vue&type=template&id=70b2b3d3&scoped=true"
import script from "./DefLabels.vue?vue&type=script&lang=js"
export * from "./DefLabels.vue?vue&type=script&lang=js"

import "./DefLabels.vue?vue&type=style&index=0&id=70b2b3d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b2b3d3"]])

export default __exports__